import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageFour from "./pages/HomePageFour";
import HomePageFive from "./pages/HomePageFive";
import HomePageSix from "./pages/HomePageSix";
import HomePageSeven from "./pages/HomePageSeven";
import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import AlertPage from "./pages/AlertPage";
import AssignRolePage from "./pages/AssignRolePage";
import AvatarPage from "./pages/AvatarPage";
import BadgesPage from "./pages/BadgesPage";
import ButtonPage from "./pages/ButtonPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import CardPage from "./pages/CardPage";
import CarouselPage from "./pages/CarouselPage";
import ChatEmptyPage from "./pages/ChatEmptyPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ChatProfilePage from "./pages/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/CodeGeneratorPage";
import ColorsPage from "./pages/ColorsPage";
import ColumnChartPage from "./pages/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/CurrenciesPage";
import DropdownPage from "./pages/DropdownPage";
import ErrorPage from "./pages/ErrorPage";
import FaqPage from "./pages/FaqPage";
import FormLayoutPage from "./pages/FormLayoutPage";
import FormValidationPage from "./pages/FormValidationPage";
import FormPage from "./pages/FormPage";
import GalleryPage from "./pages/GalleryPage";
import ImageGeneratorPage from "./pages/ImageGeneratorPage";
import ImageUploadPage from "./pages/ImageUploadPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/KanbanPage";
import LanguagePage from "./pages/LanguagePage";
import LineChartPage from "./pages/LineChartPage";
import ListPage from "./pages/ListPage";
import MarketplaceDetailsPage from "./pages/MarketplaceDetailsPage";
import MarketplacePage from "./pages/MarketplacePage";
import NotificationAlertPage from "./pages/NotificationAlertPage";
import NotificationPage from "./pages/NotificationPage";
import PaginationPage from "./pages/PaginationPage";
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import PieChartPage from "./pages/PieChartPage";
import PortfolioPage from "./pages/PortfolioPage";
import PricingPage from "./pages/PricingPage";
import ProgressPage from "./pages/ProgressPage";
import RadioPage from "./pages/RadioPage";
import RoleAccessPage from "./pages/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import StarRatingPage from "./pages/StarRatingPage";
import StarredPage from "./pages/StarredPage";
import SwitchPage from "./pages/SwitchPage";
import TableBasicPage from "./pages/TableBasicPage";
import TableDataPage from "./pages/TableDataPage";
import TabsPage from "./pages/TabsPage";
import TagsPage from "./pages/TagsPage";
import TermsConditionPage from "./pages/TermsConditionPage";
import TextGeneratorPage from "./pages/TextGeneratorPage";
import ThemePage from "./pages/ThemePage";
import TooltipPage from "./pages/TooltipPage";
import TypographyPage from "./pages/TypographyPage";
import UsersGridPage from "./pages/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/ViewDetailsPage";
import VideoGeneratorPage from "./pages/VideoGeneratorPage";
import VideosPage from "./pages/VideosPage";
import VoiceGeneratorPage from "./pages/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/WidgetsPage";
import WizardPage from "./pages/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/TextGeneratorNewPage";
import HomePageEight from "./pages/HomePageEight";
import HomePageNine from "./pages/HomePageNine";
import HomePageTen from "./pages/HomePageTen";
import HomePageEleven from "./pages/HomePageEleven";
import GalleryGridPage from "./pages/GalleryGridPage";
import GalleryMasonryPage from "./pages/GalleryMasonryPage";
import GalleryHoverPage from "./pages/GalleryHoverPage";
// import BlogPage from "./pages/BlogPage";
// import BlogDetailsPage from "./pages/BlogDetailsPage";
// import AddBlogPage from "./pages/AddBlogPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import CancellationPolicyPage from "./pages/CancellationPolicyPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import SmsPage from "./pages/SmsPage";
import Booking from "./pages/booking/Booking";
import BookingList from "./pages/booking/BookingList";
import RegisterStudent from "./pages/student/RegisterStudent";
import StudentLogin from "./pages/student/StudentLogin";
import ApprovedCounselorGrid from "./pages/student/ApprovedCounselorGrid";
import Register from "./pages/counselor/Register";
import Login from "./pages/counselor/Login";
import CalendarWithSlots from "./pages/counselor/CalendarWithSlots";
import BookingCounselorMaster from "./pages/booking/BookingCounselorMaster";
import BookingApproved from "./pages/booking/masterBooking/BookingApproved";
import BookingRejected from "./pages/booking/masterBooking/BookingRejected";
import UpcomingBooking from "./pages/booking/masterBooking/UpcomingBooking";
import CompletedBooking from "./pages/booking/masterBooking/CompletedBooking";
import BookingListStudent from "./pages/student/BookingList";
import AcceptedBookingStudent from "./pages/student/AcceptedBookingStudent";
import RejectedBookingStudent from "./pages/student/RejectedBookingStudent";
import UnpaidBookingStudent from "./pages/student/UnpaidBookingStudent";
import UpcomingBookingStudent from "./pages/student/UpcomingBookingStudent";
import CompletedBookingStudent from "./pages/student/CompletedBookingStudent";
import CounselorLayout from "./pages/counselor/CounselorLayout/CounselorLayout";
import SlotListLayout from "./pages/counselor/SlotList/SlotListLayout";
import CancellatonPolicyLayout from "./pages/Policy/CancellationPolicy/CancellatonPolicyLayout";
import ReSchedulePolicyLayout from "./pages/Policy/ReSchedulePolicy/ReSchedulePolicyLayout";
import ResetPasswordLayout from "./pages/ResetPassword/ResetPasswordLayout";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "./helper/urls";
import EarningLayout from "./pages/counselor/Earning/EarningLayout";
import AdminForgotPasswordPage from "./pages/ForgotPassword/AdminForgotPasswordPage";
import CounselorForgotPasswordPage from "./pages/ForgotPassword/CounselorForgotPasswordPage";
import StudentForgotPasswordPage from "./pages/ForgotPassword/StudentForgotPasswordPage";
import CollegeCounselorSlot from "./pages/counselor/slots/CollegeCounselorSlot";
import CollegeTourSlot from "./pages/counselor/slots/CollegeTourSlot";
import RequestLayout from "./pages/Request/RequestLayout";
import StudentCounselorPage from "./pages/student/StudentCounselorPage";
import StudentRequestedSlotList from "./pages/student/StudentRequestedSlotList";
import StudentProfile from "./pages/student/studentProfile/StudentProfile";
import StudentPayments from "./pages/student/studentPayments/StudentPayments";
import StudentResetPassword from "./pages/student/studentProfile/StudentResetPassword";
import SlotLayout from "./pages/counselor/slots/SlotLayout";
import StudentSlotBooking from "./pages/student/studentSlotBooking/StudentSlotBooking";
import PendingBookingList from "./pages/student/bookingList/PendingBookingList";
import ScheduledBookingList from "./pages/student/bookingList/ScheduledBookingList";
import CompletedBookingList from "./pages/student/bookingList/CompletedBookingList";
import PendingLayout from "./pages/counselor/ManageBooking/Pending/PendingLayout";
import ScheduleLayout from "./pages/counselor/ManageBooking/Schedule/ScheduleLayout";
import CompletedLayout from "./pages/counselor/ManageBooking/Completed/CompletedLayout";
import InvoiceLayout from "./pages/Admin/Invoice/InvoiceLayout";
import AllCounselorLayout from "./pages/Admin/Counselor/AllCounselor/AllCounselorLayout";
import PendingCounselorLayout from "./pages/Admin/Counselor/Pending/PendingCounselorLayout";
import RejectedLayout from "./pages/Admin/Counselor/Rejected/RejectedLayout";
import AddCounselorLayout from "./pages/Admin/Counselor/AddCounselor/AddCounselorLayout";
import ApprovedLayout from "./pages/Admin/Counselor/Approved/ApprovedLayout";
import AllStudentLayout from "./pages/Admin/Student/AllStudent/AllStudentLayout";
import AddStudentLayout from "./pages/Admin/Student/AddStudent/AddStudentLayout";
import EditStudentLayout from "./pages/Admin/Student/EditStudent/EditStudentLayout";
import ViewProfileLayout from "./pages/Admin/ViewProfile/ViewProfileLayout";
import StudentInvoiceLayout from "./pages/student/studentInvoice/StudentInvoiceLayout";
import EditCounselorLayout from "./pages/Admin/Counselor/EditCounselor/EditCounselorLayout";
import AdminScheduledBookingList from "./pages/Admin/adminBookings/AdminScheduledBookingList";
import AdminCompletedBookingList from "./pages/Admin/adminBookings/AdminCompletedBookingList";
import RescheduledBookingList from "./pages/counselor/ManageBooking/Schedule/RescheduledBookingList";
import AdminReScheduledBookingList from "./pages/Admin/adminBookings/AdminReScheduledBookingList";
import StudentReScheduledBookingList from "./pages/student/bookingList/StudentReScheduledBookingList";
import ProtectedRoute from "./components/ProtectedRoute";
import { useDispatch } from "react-redux";
import { loginSuccess } from "./redux/slices/authSlice";
import CreateRequestLayout from "./pages/Admin/ManageRequest/CreateRequest/CreateRequestLayout";
import CreatePolicyLayout from "./pages/Admin/CreatePolicy/CreatePolicyLayout";
import CreateFaqsLayout from "./pages/Admin/Faqs/CreateFaqsLayout";
import StudentPackage from "./pages/student/studentPackage/StudentPackage";
import PaidList from "./pages/Admin/bookSlotsForStudent/PaidList";
import AdminCancledList from "./pages/Admin/adminBookings/AdminCancledList";
import StudentSlotBookingByAdmin from "./pages/Admin/bookSlotsForStudent/StudentSlotBookingByAdmin";
import HowToWorkLayout from "./pages/Admin/HowToWork/HowToWorkLayout";
import BlogsLayout from "./pages/Admin/Blog/Blogs/BlogsLayout";
import AddBlogsLayout from "./pages/Admin/Blog/AddBlogs/AddBlogsLayout";
import BlogDetailsLayout from "./pages/Admin/Blog/BlogDetails/BlogDetailsLayout";
import StudentSidebarContent from "./pages/Admin/studentSidebarContent/StudentSidebarContent";
import CounselorCarouselLayout from "./pages/Admin/CounselorCarousel/CounselorCarouselLayout";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import WebinarLayout from "./pages/Admin/Webinar/WebinarLayout";
import CreatePackageLayout from "./pages/Admin/CreatePackage/CreatePackageLayout";
import Blog from "./pages/blog/Blog";
import BlogDetails from "./pages/blog/BlogDetails";
import BlogLayout from "./pages/blog/BlogLayout";
import PaymentLayout from "./pages/Admin/Payments/PaymentLayout";
import HelpAndSupportLayout from "./pages/student/HelpAndSupport/HelpAndSupportLayout";
import PayoutListLayout from "./pages/Admin/PayoutList/PayoutListLayout";
import CounselorHelpAndSupportLayout from "./pages/student/HelpAndSupport/CounselorHelpAndSupportLayout";
import Spinner from "./components/Spinner";
import CreateResources from "./pages/Admin/CreateResources/CreateResources";
function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const role = queryParams.get("role");

  useEffect(() => {
    const viewProfileData = async () => {
      if (!token || !role) {
        console.warn("Token or role is missing from URL query params.");
        setLoading(false);
        return;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      let endpoint = "";

      if (role === "counselor") {
        endpoint = `${baseUrl}/api/counselors/getCounselorByToken`;
      } else if (role === "student") {
        endpoint = `${baseUrl}/api/students/getStudent`;
      } else {
        console.warn("Unknown role in URL");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(endpoint, { headers });
        const profileData = response?.data?.data;
        console.log("profileData", profileData);

        if (profileData) {
          const fullName = `${profileData?.firstName || ""} ${
            profileData?.lastName || ""
          }`.trim();
          const profileImage = profileData?.profileImage
            ? `${baseUrl}${profileData.profileImage}`
            : "";

          // ✅ Dispatch Redux action instead of sessionStorage
          dispatch(
            loginSuccess({
              token,
              name: fullName,
              role,
              email: profileData?.email || "",
              status: profileData?.status || "",
              profile: profileData?.profile || "",
              document: profileData?.document || "",
              interestedIn: profileData?.interestedIn || "",
              profileImage,
            })
          );
        }

        // ✅ Route based on role/status
        if (role === "student") {
          navigate("/approved-counselor-grid");
        } else if (role === "counselor") {
          if (
            profileData?.status == 1 &&
            profileData?.profile == 1 &&
            profileData?.document == 1
          ) {
            navigate("/schedule-bookings");
          } else {
            navigate("/counselor-profile");
          }
        } else {
          navigate("/all-counselors");
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
      } finally {
        setLoading(false);
      }
    };

    viewProfileData();
  }, [token, role]);

  // Prevent rendering anything while loading
  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <RouteScrollToTop />
      <Routes>
        <Route exact path="/index-2" element={<HomePageTwo />} />
        <Route exact path="/index-4" element={<HomePageFour />} />
        <Route exact path="/index-5" element={<HomePageFive />} />
        <Route exact path="/index-6" element={<HomePageSix />} />
        <Route exact path="/index-7" element={<HomePageSeven />} />
        <Route exact path="/index-8" element={<HomePageEight />} />
        <Route exact path="/index-9" element={<HomePageNine />} />
        <Route exact path="/index-10" element={<HomePageTen />} />
        <Route exact path="/index-11" element={<HomePageEleven />} />
        {/* SL */}
        <Route exact path="/add-user" element={<AddUserPage />} />
        <Route exact path="/alert" element={<AlertPage />} />
        <Route exact path="/assign-role" element={<AssignRolePage />} />
        <Route exact path="/avatar" element={<AvatarPage />} />
        <Route exact path="/badges" element={<BadgesPage />} />
        <Route exact path="/button" element={<ButtonPage />} />
        <Route exact path="/calendar-main" element={<CalendarMainPage />} />
        <Route exact path="/calendar" element={<CalendarMainPage />} />
        <Route exact path="/card" element={<CardPage />} />
        <Route exact path="/carousel" element={<CarouselPage />} />
        <Route exact path="/chat-empty" element={<ChatEmptyPage />} />
        <Route exact path="/chat-message" element={<ChatMessagePage />} />
        <Route exact path="/chat-profile" element={<ChatProfilePage />} />
        <Route exact path="/code-generator" element={<CodeGeneratorPage />} />
        <Route
          exact
          path="/code-generator-new"
          element={<CodeGeneratorNewPage />}
        />
        <Route exact path="/colors" element={<ColorsPage />} />
        <Route exact path="/column-chart" element={<ColumnChartPage />} />
        <Route exact path="/company" element={<CompanyPage />} />
        <Route exact path="/currencies" element={<CurrenciesPage />} />
        <Route exact path="/dropdown" element={<DropdownPage />} />
        <Route exact path="/email" element={<EmailPage />} />
        <Route exact path="/faq" element={<FaqPage />} />
        <Route
          exact
          path="/admin-forgot-password"
          element={<AdminForgotPasswordPage />}
        />
        <Route
          exact
          path="/counselor-forgot-password"
          element={<CounselorForgotPasswordPage />}
        />
        <Route
          exact
          path="/student-forgot-password"
          element={<StudentForgotPasswordPage />}
        />
        <Route exact path="/form-layout" element={<FormLayoutPage />} />
        <Route exact path="/form-validation" element={<FormValidationPage />} />
        <Route exact path="/form" element={<FormPage />} />
        <Route exact path="/gallery" element={<GalleryPage />} />
        <Route exact path="/gallery-grid" element={<GalleryGridPage />} />
        <Route exact path="/gallery-masonry" element={<GalleryMasonryPage />} />
        <Route exact path="/gallery-hover" element={<GalleryHoverPage />} />
        {/* <Route exact path="/blog" element={<BlogPage />} />
        <Route exact path="/blog-details" element={<BlogDetailsPage />} />
        <Route exact path="/add-blog" element={<AddBlogPage />} /> */}
        <Route exact path="/testimonials" element={<TestimonialsPage />} />
        <Route exact path="/coming-soon" element={<ComingSoonPage />} />
        <Route exact path="/access-denied" element={<AccessDeniedPage />} />
        <Route exact path="/maintenance" element={<MaintenancePage />} />
        <Route exact path="/blank-page" element={<BlankPagePage />} />
        <Route exact path="/image-generator" element={<ImageGeneratorPage />} />
        <Route exact path="/image-upload" element={<ImageUploadPage />} />
        <Route exact path="/invoice-add" element={<InvoiceAddPage />} />
        <Route exact path="/invoice-edit" element={<InvoiceEditPage />} />
        <Route exact path="/invoice-list" element={<InvoiceListPage />} />
        <Route exact path="/invoice-preview" element={<InvoicePreviewPage />} />
        <Route exact path="/kanban" element={<KanbanPage />} />
        <Route exact path="/language" element={<LanguagePage />} />
        <Route exact path="/line-chart" element={<LineChartPage />} />
        <Route exact path="/list" element={<ListPage />} />
        <Route
          exact
          path="/marketplace-details"
          element={<MarketplaceDetailsPage />}
        />
        <Route exact path="/marketplace" element={<MarketplacePage />} />
        <Route
          exact
          path="/notification-alert"
          element={<NotificationAlertPage />}
        />
        <Route exact path="/notification" element={<NotificationPage />} />
        <Route exact path="/pagination" element={<PaginationPage />} />
        <Route exact path="/payment-gateway" element={<PaymentGatewayPage />} />
        <Route exact path="/pie-chart" element={<PieChartPage />} />
        <Route exact path="/portfolio" element={<PortfolioPage />} />
        <Route exact path="/pricing" element={<PricingPage />} />
        <Route exact path="/progress" element={<ProgressPage />} />
        <Route exact path="/radio" element={<RadioPage />} />
        <Route exact path="/role-access" element={<RoleAccessPage />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/star-rating" element={<StarRatingPage />} />
        <Route exact path="/starred" element={<StarredPage />} />
        <Route exact path="/switch" element={<SwitchPage />} />
        <Route exact path="/table-basic" element={<TableBasicPage />} />
        <Route exact path="/table-data" element={<TableDataPage />} />
        <Route exact path="/tabs" element={<TabsPage />} />
        <Route exact path="/tags" element={<TagsPage />} />
        {/* Paths added by Pralabh Gupta for DreamDor */}
        <Route exact path="/" element={<SignInPage />} />
        <Route
          exact
          path="/terms-condition-setting"
          element={<TermsConditionPage />}
        />
        <Route
          exact
          path="/privacy-policy-setting"
          element={<PrivacyPolicyPage />}
        />
        <Route
          exact
          path="/cancellation-policy-setting"
          element={<CancellationPolicyPage />}
        />
        <Route
          exact
          path="/refund-policy-setting"
          element={<RefundPolicyPage />}
        />
        <Route exact path="/sms-setting" element={<SmsPage />} />
        <Route exact path="/email-setting" element={<EmailPage />} />
        {/* /////////////////// ADMIN ROUTES //////////////////// */}
        <Route
          path="/all-counselors"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AllCounselorLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-counselor"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AddCounselorLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-counselor/:id"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <EditCounselorLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/approved-counselor"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <ApprovedLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/unapproved-counselor"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <RejectedLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pending-counselor"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <PendingCounselorLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/add-student"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AddStudentLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-profile"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <ViewProfileLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/all-students"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AllStudentLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-student/:id"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <EditStudentLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/request"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <RequestLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-request"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <CreateRequestLayout />
            </ProtectedRoute>
          }
        />

        <Route
          path="/invoice"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <InvoiceLayout />
            </ProtectedRoute>
          }
        />

        {/* <Route
          path="/blog"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <BlogsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/blog-details"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <BlogDetailsLayout />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/add-blog"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AddBlogsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-faqs"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <CreateFaqsLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-policy"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <CreatePolicyLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/how-to-work"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <HowToWorkLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/counselor-carousel"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <CounselorCarouselLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/webinar"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <WebinarLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-package"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <CreatePackageLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <PaymentLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/payout-list"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <PayoutListLayout />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-book-slot-for-student"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <PaidList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/canceled-booking-by-admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminCancledList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sidebar-content-by-admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <StudentSidebarContent />
            </ProtectedRoute>
          }
        />
        <Route
          path="/create-resources"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <CreateResources />
            </ProtectedRoute>
          }
        />

        <Route
          path="/rescheduled-booking-by-admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminReScheduledBookingList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/scheduled-booking-by-admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminScheduledBookingList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/completed-booking-by-admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminCompletedBookingList />
            </ProtectedRoute>
          }
        />

        {/* /////////////////// COUNSELOR ROUTES //////////////////// */}
        <Route
          path="/counselor-profile"
          element={
            <ProtectedRoute allowedRoles={["counselor"]}>
              <CounselorLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/earning"
          element={
            <ProtectedRoute allowedRoles={["counselor"]}>
              <EarningLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/essay-counseling-slot"
          element={
            <ProtectedRoute allowedRoles={["counselor"]}>
              <SlotLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <ProtectedRoute allowedRoles={["counselor"]}>
              <ResetPasswordLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pending-bookings"
          element={
            <ProtectedRoute allowedRoles={["counselor"]}>
              <PendingLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/schedule-bookings"
          element={
            <ProtectedRoute allowedRoles={["counselor"]}>
              <ScheduleLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reschedule-bookings"
          element={
            <ProtectedRoute allowedRoles={["counselor"]}>
              <RescheduledBookingList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/counselor-completed-bookings"
          element={
            <ProtectedRoute allowedRoles={["counselor"]}>
              <CompletedLayout />
            </ProtectedRoute>
          }
        />
        {/* /////////////////// STUDENT ROUTES //////////////////// */}
        {/* jaspal */}
        {/* Register student page by jaspal */}
        <Route exact path="/student-register" element={<RegisterStudent />} />
        {/* <Route exact path="/student-login" element={<StudentLogin />} /> */}
        <Route
          path="/approved-counselor-grid"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <ApprovedCounselorGrid />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-requested-slot-list"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentRequestedSlotList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-profile"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentProfile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-scheduled-booking-list"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <ScheduledBookingList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-rescheduled-booking-list"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentReScheduledBookingList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-completed-booking-list"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <CompletedBookingList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-invoice-list"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentInvoiceLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-counselor/:id"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentCounselorPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-slot-booking"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentSlotBooking />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-slot-booking-by-admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <StudentSlotBookingByAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student-reset-password"
          element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentResetPassword />
            </ProtectedRoute>
          }
        />

        {/* ///////////////////////// ROUTES FOR ALL ROLES //////////////////////// */}

        <Route path="/help-and-support" element={<HelpAndSupportLayout />} />
        <Route
          path="/counselor-help-and-support"
          element={<CounselorHelpAndSupportLayout />}
        />
        <Route
          path="/cancellation-policy"
          element={<CancellatonPolicyLayout />}
        />
        <Route path="/reschedule-policy" element={<ReSchedulePolicyLayout />} />

        {/* <Route exact path="*" element={<PageNotFound />} /> */}

        {/* <Route path="/counselor-slot" element={<CalendarWithSlots />} />
        <Route
          path="/college-counseling-slot"
          element={<CollegeCounselorSlot />}
        />
        <Route path="/college-tour-slot" element={<CollegeTourSlot />} />
        <Route path="/slot-list" element={<SlotListLayout />} /> */}
        {/* Paths added by Pralabh Gupta for DreamDor end */}
        <Route
          exact
          path="/text-generator-new"
          element={<TextGeneratorNewPage />}
        />
        <Route exact path="/text-generator" element={<TextGeneratorPage />} />
        <Route exact path="/theme" element={<ThemePage />} />
        <Route exact path="/tooltip" element={<TooltipPage />} />
        <Route exact path="/typography" element={<TypographyPage />} />
        <Route exact path="/users-grid" element={<UsersGridPage />} />
        <Route exact path="/users-list" element={<UsersListPage />} />
        <Route exact path="/view-details" element={<ViewDetailsPage />} />
        <Route exact path="/video-generator" element={<VideoGeneratorPage />} />
        <Route exact path="/videos" element={<VideosPage />} />
        <Route exact path="/voice-generator" element={<VoiceGeneratorPage />} />
        <Route exact path="/wallet" element={<WalletPage />} />
        <Route exact path="/widgets" element={<WidgetsPage />} />
        <Route exact path="/wizard" element={<WizardPage />} />
        <Route exact path="/bookings" element={<Booking />} />
        <Route exact path="/all-booking" element={<BookingList />} />
        <Route
          exact
          path="/student-pending-booking"
          element={<BookingListStudent status={0} />}
        />
        <Route
          exact
          path="/student-accepted-booking"
          element={<AcceptedBookingStudent status={1} />}
        />
        <Route
          exact
          path="/student-rejected-booking"
          element={<RejectedBookingStudent status={3} />}
        />
        <Route
          exact
          path="/student-paid-booking"
          element={<UnpaidBookingStudent status={2} />}
        />
        <Route
          exact
          path="/student-upcoming-booking"
          element={<UpcomingBookingStudent status={4} />}
        />
        <Route
          exact
          path="/student-completed-booking"
          element={<CompletedBookingStudent status={5} />}
        />
        {/* edited by chandan  */}
        <Route exact path="/student-payments" element={<StudentPayments />} />
        <Route exact path="/register" element={<Register />} />
        <Route exact path="/login" element={<Login />} />
        <Route
          exact
          path="/booking-counselor"
          element={<BookingCounselorMaster />}
        />
        <Route exact path="/approved-bookings" element={<BookingApproved />} />
        <Route
          exact
          path="/unapproved-bookings"
          element={<BookingRejected />}
        />
        <Route exact path="/upcoming-bookings" element={<UpcomingBooking />} />
        <Route
          exact
          path="/completed-bookings"
          element={<CompletedBooking />}
        />
        {/* //// jaspal routes/////////// */}
        <Route
          exact
          path="/student-pending-booking-list"
          element={<PendingBookingList />}
        />
        <Route exact path="/student-package" element={<StudentPackage />} />

        {/* <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetails />} /> */}
        <Route path="/blog" element={<BlogLayout />}>
          <Route index element={<Blog />} />
          <Route path=":slug" element={<BlogDetails />} />
        </Route>

        {/* <Route exact path="*" element={<ErrorPage />} /> */}
      </Routes>
    </>
  );
}

export default App;
